/** @format */
import { AxiosRequestConfig } from 'axios';

import { transformProductSummaryResponse } from '@toucan/common/services/product/serializers';

import { client } from '@toucan/client/global/axios';
import { MarketCode, defaultMarket } from '@toucan/client/global/market';
import { ProductSummaryV2 } from '@toucan/client/global/product';

/**
 * Returns a product summary for a product, irrespective of the state of that
 * product, e.g. Reserved or Allocated.
 *
 * @param id The id of the product to get the details for
 * @param market the market that they're in
 */
export async function getProductSummary(
    id: number,
    market: MarketCode = defaultMarket.code
): Promise<ProductSummaryV2> {
    const config: AxiosRequestConfig = {
        headers: {
            'X-Market': market.toLowerCase(),
        },
    };

    const { data } = await client.get(
        `/products/display/v2/${id}/summary/`,
        config
    );

    return transformProductSummaryResponse(data);
}
